var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-empty"},[_c('img',{attrs:{"src":require("@/assets/img/empty.png"),"alt":""}}),_c('p',[_vm._v("暂无商品")])])
}]

export { render, staticRenderFns }